import React, { useState, useEffect } from 'react';
import { Cookie, X } from '@phosphor-icons/react';

/**
 * Bandeau cookies conforme RGPD (art. 82 Loi Informatique & Libertés)
 * - "Refuser" aussi visible que "Accepter"
 * - Aucun cookie non essentiel déposé avant consentement
 */
export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si le consentement a déjà été donné
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      data-testid="cookie-banner"
      className="fixed bottom-[var(--regulatory-h)] left-0 right-0 z-[100] bg-slate-900 border-t border-slate-700 p-4 shadow-2xl"
    >
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Icône et texte */}
          <div className="flex items-start gap-3 flex-1">
            <Cookie size={24} weight="duotone" className="text-amber-400 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-white mb-1">Gestion des cookies</h4>
              <p className="text-xs text-slate-400 leading-relaxed">
                Ce site utilise des cookies strictement nécessaires au fonctionnement du service. 
                Aucun cookie non essentiel n'est déposé sans votre consentement explicite.
                {' '}
                <a 
                  href="/confidentialite" 
                  className="text-blue-400 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Politique de confidentialité
                </a>
              </p>
            </div>
          </div>

          {/* Boutons - même taille et visibilité */}
          <div className="flex gap-3 w-full md:w-auto">
            <button
              data-testid="cookie-refuse"
              onClick={handleRefuse}
              className="flex-1 md:flex-none px-6 py-2.5 rounded-lg border border-slate-600 text-slate-300 text-sm font-medium hover:bg-slate-800 hover:border-slate-500 transition-colors"
            >
              Refuser
            </button>
            <button
              data-testid="cookie-accept"
              onClick={handleAccept}
              className="flex-1 md:flex-none px-6 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
